import { render } from "./ModalUserConsentHandler.vue?vue&type=template&id=624f4a3f"
import script from "./ModalUserConsentHandler.vue?vue&type=script&lang=js"
export * from "./ModalUserConsentHandler.vue?vue&type=script&lang=js"

import "./ModalUserConsentHandler.vue?vue&type=style&index=0&id=624f4a3f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__